var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilkBottole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3C8.5 2.44772 8.94772 2 9.5 2H13.5C14.0523 2 14.5 2.44772 14.5 3V4H8.5V3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50001 5.5H14.5V6.47059L16.0559 9.49086C16.2943 9.95372 16.4396 10.4576 16.4848 10.9741C16.0454 11.294 15.3409 11.5659 14.3987 11.6944C13.1359 11.8666 11.6268 11.7517 10.2372 11.2885C8.6196 10.7493 7.36187 10.8506 6.50153 11.2124C6.51806 10.6131 6.66912 10.0247 6.94411 9.49086L8.50001 6.47059V5.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.0593V20C6.5 21.1046 7.39543 22 8.5 22H14.5C15.6046 22 16.5 21.1046 16.5 20V12.6748C15.9199 12.9258 15.2649 13.0901 14.6013 13.1806C13.1141 13.3834 11.3732 13.2484 9.76283 12.7115C7.57203 11.9813 6.71163 12.7847 6.62404 12.9161C6.58803 12.9701 6.54622 13.0179 6.5 13.0593Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilkBottole);
export default __webpack_public_path__ + "static/media/milk-bottole.2104da207a43ea4f2167da208a146b41.svg";
export { ForwardRef as ReactComponent };